import {
  LISTA_JUSTIFICATIVAS_FALTA,
  LISTA_JUSTIFICATIVAS_FALTA_SUCESSO,
  CRIA_JUSTIFICATIVA_FALTA,
  CRIA_JUSTIFICATIVA_FALTA_SUCESSO,
  EDITA_JUSTIFICATIVA_FALTA,
  EDITA_JUSTIFICATIVA_FALTA_SUCESSO,
  REMOVE_JUSTIFICATIVA_FALTA,
  REMOVE_JUSTIFICATIVA_FALTA_SUCESSO,
  DESVINCULAR_JUSTIFICATIVA_FALTA,
  DESVINCULAR_JUSTIFICATIVA_FALTA_SUCESSO,
  CALCULO_JUSTIFICATIVA_FALTA,
  CALCULO_JUSTIFICATIVA_FALTA_SUCESSO,
  ADICIONA_ANEXOS_JUSTIFICATIVA_FALTA,
  ADICIONA_ANEXOS_JUSTIFICATIVA_FALTA_SUCESSO,
  REMOVE_ANEXO_JUSTIFICATIVA_FALTA,
  REMOVE_ANEXO_JUSTIFICATIVA_FALTA_SUCESSO,
  JUSTIFICATIVA_FALTA_ERRO,
  LIMPA_CONTEXTO_JUSTIFICATIVA_FALTA,
} from 'constants/ActionTypes';

// Lista as justificativas do contexto aberto no modal (matriculaId obrigatório;
// componenteEscolaId/periodoAnoLetivoId filtram o contexto).
export const listaJustificativasFalta = (contexto) => ({
  type: LISTA_JUSTIFICATIVAS_FALTA,
  payload: contexto,
});

export const listaJustificativasFaltaSucesso = (lista) => ({
  type: LISTA_JUSTIFICATIVAS_FALTA_SUCESSO,
  payload: lista,
});

// Cria uma justificativa. payload = { dados (camelCase p/ API), arquivos (File[]), contexto }
export const criaJustificativaFalta = (payload) => ({
  type: CRIA_JUSTIFICATIVA_FALTA,
  payload,
});

export const criaJustificativaFaltaSucesso = () => ({
  type: CRIA_JUSTIFICATIVA_FALTA_SUCESSO,
});

// Edita uma justificativa existente (PUT multipart).
// payload = { id, dados (camelCase p/ API), arquivosManterIds (number[]|undefined),
//             arquivos (File[] novos), contexto (p/ refresh) }
export const editaJustificativaFalta = (payload) => ({
  type: EDITA_JUSTIFICATIVA_FALTA,
  payload,
});

export const editaJustificativaFaltaSucesso = () => ({
  type: EDITA_JUSTIFICATIVA_FALTA_SUCESSO,
});

// Remove uma justificativa. payload = { id, contexto (p/ refresh) }
export const removeJustificativaFalta = (payload) => ({
  type: REMOVE_JUSTIFICATIVA_FALTA,
  payload,
});

export const removeJustificativaFaltaSucesso = () => ({
  type: REMOVE_JUSTIFICATIVA_FALTA_SUCESSO,
});

export const desvincularJustificativaFalta = (payload) => ({
  type: DESVINCULAR_JUSTIFICATIVA_FALTA,
  payload,
});

export const desvincularJustificativaFaltaSucesso = () => ({
  type: DESVINCULAR_JUSTIFICATIVA_FALTA_SUCESSO,
});

// Recalcula a sugestão (faltasJustificadas por componente) de uma matrícula/etapa.
export const calculoJustificativaFalta = (contexto) => ({
  type: CALCULO_JUSTIFICATIVA_FALTA,
  payload: contexto,
});

export const calculoJustificativaFaltaSucesso = (resultado) => ({
  type: CALCULO_JUSTIFICATIVA_FALTA_SUCESSO,
  payload: resultado, // { matriculaId, porComponente }
});

// Adiciona anexos a uma justificativa existente. payload = { id, arquivos (File[]), contexto }
export const adicionaAnexosJustificativaFalta = (payload) => ({
  type: ADICIONA_ANEXOS_JUSTIFICATIVA_FALTA,
  payload,
});

export const adicionaAnexosJustificativaFaltaSucesso = () => ({
  type: ADICIONA_ANEXOS_JUSTIFICATIVA_FALTA_SUCESSO,
});

// Remove um anexo. payload = { id, arquivoId, contexto }
export const removeAnexoJustificativaFalta = (payload) => ({
  type: REMOVE_ANEXO_JUSTIFICATIVA_FALTA,
  payload,
});

export const removeAnexoJustificativaFaltaSucesso = () => ({
  type: REMOVE_ANEXO_JUSTIFICATIVA_FALTA_SUCESSO,
});

export const justificativaFaltaErro = (mensagem) => ({
  type: JUSTIFICATIVA_FALTA_ERRO,
  payload: mensagem,
});

export const limpaContextoJustificativaFalta = () => ({
  type: LIMPA_CONTEXTO_JUSTIFICATIVA_FALTA,
});
